export function normalizeAuthRedirectPath (path) {
  if (typeof path !== 'string') return null

  const trimmed = path.trim()
  if (!trimmed.length) return null

  // Avoid open redirects.
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) {
    return null
  }

  return trimmed
}

export function buildGoogleAuthStartUrl (apiBaseUrl, {
  mode = 'login',
  redirectPath = null,
  startPath = '/auth/google/redirect'
} = {}) {
  if (typeof apiBaseUrl !== 'string' || !apiBaseUrl.trim()) {
    throw new Error('Missing apiBaseUrl for Google auth start URL')
  }

  const base = apiBaseUrl.trim().replace(/\/+$/, '')
  const normalizedStartPath = (startPath || '/auth/google/redirect').startsWith('/')
    ? startPath
    : `/${startPath}`

  const params = new URLSearchParams()
  if (mode) params.set('mode', mode)

  const safeRedirectPath = normalizeAuthRedirectPath(redirectPath)
  if (safeRedirectPath) {
    params.set('redirect', safeRedirectPath)
  }

  if (localStorage.getItem('auth_provider_user_id')) {
    params.set('auth_provider_user_id', localStorage.getItem('auth_provider_user_id'))
  }

  return `${base}${normalizedStartPath}${params.toString() ? `?${params.toString()}` : ''}`
}

export function getGoogleAuthJWT (payload) {
  const candidate = payload?.data?.jwt ?? null

  if (typeof candidate !== 'string' || candidate.length < 20) {
    return null
  }

  return candidate
}

export function getGoogleAuthRedirectPath (payload, fallbackPath = null) {
  return normalizeAuthRedirectPath(payload?.data?.redirect) || normalizeAuthRedirectPath(fallbackPath)
}

export function isGoogleProviderResetError (error) {
  const message = error?.response?.data?.message
  if (typeof message !== 'string' || !message.trim()) {
    return false
  }

  const normalized = message.toLowerCase()
  return normalized.includes('uses google') || normalized.includes('you should reset your password')
}

export function isGoogleProviderAuthError (error) {
  const message = error?.response?.data?.message
  if (typeof message !== 'string' || !message.trim()) {
    return false
  }

  const normalized = message.toLowerCase()
  return normalized.includes('with google')
}
